import { colorTypeHelper } from 'utils/colorUtility';
import { getCookieSanitized } from 'utils/cookieUtility';
import { getRichTextValue } from 'utils/richTextUtils';
import usePlumbingBlogPosts from 'hooks/blogsByIndustry/usePlumbingBlogPosts';
import useAllIndustriesBlogPosts from 'hooks/blogsByIndustry/useAllIndustriesBlogPosts';
import useChimneySweepBlogPosts from 'hooks/blogsByIndustry/useChimneySweepBlogPosts';
import useElectricalBlogPosts from 'hooks/blogsByIndustry/useElectricalBlogPosts';
import useGarageDoorBlogPosts from 'hooks/blogsByIndustry/useGarageDoorBlogPosts';
import useHvacBlogPosts from 'hooks/blogsByIndustry/useHvacBlogPosts';
import useLandscapingBlogPosts from 'hooks/blogsByIndustry/useLandscapingBlogPosts';
import useOtherIndustriesBlogPosts from 'hooks/blogsByIndustry/useOtherIndustriesBlogPosts';
import usePestControlBlogPosts from 'hooks/blogsByIndustry/usePestControlBlogPosts';
import useSubcontractorBlogPosts from 'hooks/blogsByIndustry/useSubcontractorBlogPosts';
import useWaterTreatmentBlogPosts from 'hooks/blogsByIndustry/useWaterTreatmentBlogPosts';
import useRecentBlogPosts from 'hooks/blogsByIndustry/useRecentBlogPosts';
import { getEntry } from './entriesHelpers';
import useCommercialToolboxContentHub from 'hooks/useCommercialToolboxContentHub';
import { ctaTypeMap } from 'components/Page/Toolbox/utils';

export const getCtaCardsProps = (entries) => {
  let industryCards;
  const recentPosts = useRecentBlogPosts();
  const richTextEntry = entries?.find((entry) => entry['__typename'] === 'ContentfulRichText');
  const styleEntry = entries?.find((entry) => entry['__typename'] === 'ContentfulSection')?.styles;
  const title = richTextEntry?.sectionTitle;
  const bgColor = colorTypeHelper?.[styleEntry?.backgroundColor];

  const industry =
    getCookieSanitized('industry') ||
    getCookieSanitized('otherIndustry') ||
    entries?.find((entry) => entry['__typename'] === 'ContentfulTaxonomy')?.industries?.[0];

  const staticCards = entries
    ?.find((entry) => entry['__typename'] === 'ContentfulComponentCollection')
    ?.components?.slice(0, 3);

  switch (industry) {
    case 'Plumbing':
      industryCards = usePlumbingBlogPosts();
      break;
    case 'All Industries':
      industryCards = useAllIndustriesBlogPosts();
      break;
    case 'Chimeny Sweep':
      industryCards = useChimneySweepBlogPosts();
      break;
    case 'Electrical':
      industryCards = useElectricalBlogPosts();
      break;
    case 'Garage Door':
      industryCards = useGarageDoorBlogPosts();
      break;
    case 'HVAC':
      industryCards = useHvacBlogPosts();
      break;
    case 'Landscaping':
      industryCards = useLandscapingBlogPosts();
      break;
    case 'Other Industries':
      industryCards = useOtherIndustriesBlogPosts();
      break;
    case 'Pest Control':
      industryCards = usePestControlBlogPosts();
      break;
    case 'Subcontreactor':
      industryCards = useSubcontractorBlogPosts();
      break;
    case 'Water Treatment':
      industryCards = useWaterTreatmentBlogPosts();
      break;
  }

  return {
    cardInfo: industryCards?.length
      ? industryCards
      : staticCards?.length
      ? staticCards
      : recentPosts,
    cardType: 'Image',
    bodyType: 'learn-more',
    title,
    textColor: 'var(--darkest)',
    backgroundColor: `var(${bgColor})`,
    industry,
  };
};

export const getComparisonCardsProps = (entries) => {
  const subtitle = getRichTextValue(getEntry('subtitle', entries));
  const title = getRichTextValue(getEntry('title', entries));

  return {
    cardInfo: entries?.[0]?.components?.map((card) => {
      return {
        link: card?.ctaLink,
        logo: card?.icon?.image?.file?.url,
        company: card?.title,
      };
    }),
    description: subtitle,
    title,
  };
};

export const getWireProps = (entries) => {
  const includedPost = entries.find((entry) => ctaTypeMap[entry?.__typename]);

  return { includedPost };
};
